import { RecipientsViewModel } from "../../../domain/RecipientsViewModel";
import { ActionType } from "./types";

export const buildActions = (
  action: (entity: ActionType | null) => void,
  disabled: boolean,
  recipients: RecipientsViewModel | undefined,
  isDraft: boolean
) => {

  console.log("Send Message button", recipients);

  const assignStaff = {
    label: "Assign",
    dataTest: "assign-staff",
    action: () => action(ActionType.AssignStaff),
    disabled: disabled || !recipients?.orgs.some((org) => org.isSelected),
  };

  const manageRecipients = {
    label: "Manage Recipients",
    dataTest: "manage-recipients",
    action: () => action(ActionType.ManageRecipients),
    disabled: disabled,
  };

  const sendMessage = {
    label: "Send Message",
    dataTest: "send-message",
    action: () => action(ActionType.SendMessage),
    disabled: disabled || isDraft || !recipients?.orgs.some((org) => org.isSelected),
  };

  const close = {
    label: "Close",
    dataTest: "close",
    action: () => action(ActionType.Close),
    disabled: disabled || !recipients?.orgs.some((org) => org.isSelected),
  };

  return [sendMessage, manageRecipients, assignStaff, close];
};
